<template>
  <div class="client-code" @click="showOverlay">{{ custno }}</div>
</template>

<script>

export default {
  name: 'ClientCode',
  props: {
    custno: {
      required: true,
      type: String
    }
  },
  components: {},
  methods: {
    showOverlay () {

      alert('TODO: Fix overlays - Jake')

    }
  }
}
</script>

<style scoped>
  .client-code {
    cursor: pointer;
    color: blue;
  }
</style>
